import "../App.css";
import { resetFeedFilter } from "../redux/actions";
import { useAppDispatch } from "../redux/store/hooks";
import ChartMap from "../components/ChartMap";
import ChartMapIndustry from "../components/ChartMapIndustry";
import TopSources from "../components/TopSources";
import FeedGeneral from "../components/feed-general/FeedGeneral";
import NumberOfMentions from "../components/NumberOfMentions";


function Main() {
  const dispatch = useAppDispatch();
  dispatch(resetFeedFilter());

  return (
    <div className="App">
      <h2>Аналитика по региону</h2>
      <ChartMap />
      <TopSources type={"inc"} />
      <TopSources type={"dec"} />
      <NumberOfMentions/>
      <ChartMapIndustry />
      <FeedGeneral />
    </div>
  );
}

export default Main;
